import { useStoredCooldown } from '@web-app/hooks/utils/useStoredCooldown';

export const AVAILABILITY_REMINDER_MODAL_INTERVAL_MS = 4 * 60 * 60 * 1000;
export const AVAILABILITY_REMINDER_LAST_SHOWN_KEY =
  'availability-reminder:last-shown';

export const useAvailabilityReminderCooldown = () =>
  useStoredCooldown(
    AVAILABILITY_REMINDER_LAST_SHOWN_KEY,
    AVAILABILITY_REMINDER_MODAL_INTERVAL_MS,
  );
